import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const getInitialAuth = () => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    return !!token;
  };

  const [isAuthenticated, setIsAuthenticated] = useState(getInitialAuth);
  const [loading, setLoading] = useState(false);


  const login = (token, userInfo) => {
    try {
      localStorage.setItem('token', token);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    } catch (error) {
      try {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
      } catch (sessionError) {
        console.error('Failed to save to localStorage and sessionStorage:', sessionError);
      }
    }
    setIsAuthenticated(true);
  };

  const logout = useCallback(() => {
    setIsAuthenticated(false);
    
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userInfo');
  }, []);

  useEffect(() => {
    const handleLogout = () => {
      logout();
    };
    window.addEventListener('auth:logout', handleLogout);
    return () => window.removeEventListener('auth:logout', handleLogout);
  }, [logout]);

  const value = {
    isAuthenticated,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};